import {
    WorkflowActionTypeEnum,
    WorkflowTriggerTypeEnum,
    WorkflowUtilityNodeTypeEnum,
} from 'constants/workflows';

const baseNodeDefaults = {
    position: { x: 0, y: 0 },
    data: undefined,
    selected: false,
    style: { opacity: 0 },
};

const actionNodeTypes: string[] = Object.values(WorkflowActionTypeEnum);
const triggerNodeTypes: string[] = Object.values(WorkflowTriggerTypeEnum);
const utilityNodeTypes: string[] = [
    WorkflowUtilityNodeTypeEnum.LEAF_END,
    WorkflowUtilityNodeTypeEnum.CHOOSE_ACTION,
];

export { baseNodeDefaults, actionNodeTypes, triggerNodeTypes, utilityNodeTypes };
